<div *ngIf="showSpinner" class="waiting-spinner">
  <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
  <p>{{ isSaving ? 'Submitting...' : 'Loading...' }}</p>
</div>
<div fxLayout="column" fxLayoutAlign="center center" [fxHide]="showSpinner" class="survey neutral-theme">
  <div class="title-container" fxLayout="column" fxLayoutAlign="center center">
    <h1 *ngIf="!inPreviewMode && form.formType == 'Team'">
      {{ application?.publicTeamName ? application?.publicTeamName : application?.teamName }}
    </h1>
    <h2>{{ form?.title }}</h2>
  </div>
  <div
    class="introduction-text"
    *ngIf="isIntroductionVisible && isAppLoaded()"
    [innerHTML]="form?.introduction | safeHtml"
  ></div>
  <button
    mat-raised-button
    color="primary"
    class="start-button"
    *ngIf="isIntroductionVisible && isAppLoaded()"
    (click)="startApplication()"
  >
    NEXT <mat-icon>arrow_forward</mat-icon>
  </button>
  <div class="main-container" [ngClass]="{ 'd-none': isIntroductionVisible || !isAppLoaded() }">
    <span class="instructions"
      >Please complete or update the contact information below. Items marked with a <span class="required">*</span> are
      required.</span
    >

    <mat-stepper linear class="stepper" #stepper (selectionChange)="stepperChange($event)">
      <mat-step *ngFor="let page of formPages; let i = index" [completed]="isPageValid(page)">
        <h2 *ngIf="i != 0" class="font-24 mb-24">{{ page.name }}</h2>
        <span *ngIf="i != 0" [innerHTML]="page.description | safeHtml"></span>
        <mat-divider *ngIf="i != 0" style="margin-bottom: 30px"></mat-divider>
        <div *ngIf="i == 0">
          <form [formGroup]="applicationForm">
            <div fxLayout="column">
              <div fxLayoutAlign="center center" fxLayout="column" *ngIf="isAvatarVisible()">
                <cloudinary-upload
                  [imageChangedCallback]="imageChangedCallbackReference()"
                  [errorCallback]="imageErrorCallbackReference()"
                  [image]="image"
                  [alwaysShowIcons]="true"
                ></cloudinary-upload>
              </div>
              <div class="cloudinary-error-container" fxLayoutAlign="center center">
                <label class="cloudinary-error-message" *ngIf="this.errorMessage">{{ this.errorMessage }}</label>
              </div>
              <div
                fxLayout="column"
                fxLayout.gt-xs="row"
                fxLayoutAlign="space-between"
                fxLayoutGap="10px"
                class="application-row"
              >
                <div fxFlex="grow" class="name">
                  <label for="field-firstName"
                    >First name <span class="required" aria-label="This is a required field">*</span></label
                  >
                  <mat-form-field appearance="outline" floatLabel="never">
                    <input
                      matInput
                      forbidAngleBrackets
                      id="field-firstName"
                      type="text"
                      formControlName="firstName"
                      autocomplete="given-name"
                      placeholder="Required"
                      (change)="updateFieldValidatorStatus(page)"
                    />
                    <mat-error *ngIf="applicationForm.controls.firstName.hasError('notEmpty')">
                      {{ applicationForm.controls.firstName.getError('notEmpty') }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="grow" class="name" *ngIf="isMiddleNameVisible()">
                  <label for="field-middleName"
                    >Middle name<span class="required">{{ getRequiredFor('MiddleName') }}</span></label
                  >
                  <mat-form-field appearance="outline" floatLabel="always">
                    <input
                      matInput
                      forbidAngleBrackets
                      type="text"
                      formControlName="middleName"
                      id="field-middleName"
                      autocomplete="middle-name"
                      [placeholder]="getPlaceholderFor('MiddleName')"
                      (change)="updateFieldValidatorStatus(page)"
                    />
                    <mat-error *ngIf="applicationForm.controls.middleName.hasError('notEmpty')">
                      {{ applicationForm.controls.middleName.getError('notEmpty') }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="grow" class="name">
                  <label for="field-lastName"
                    >Last name <span class="required" aria-label="This is a required field">*</span></label
                  >
                  <mat-form-field appearance="outline" floatLabel="never">
                    <input
                      matInput
                      forbidAngleBrackets
                      type="text"
                      formControlName="lastName"
                      id="field-lastName"
                      autocomplete="family-name"
                      placeholder="Required"
                      (change)="updateFieldValidatorStatus(page)"
                    />
                    <mat-error *ngIf="applicationForm.controls.lastName.hasError('notEmpty')">
                      {{ applicationForm.controls.lastName.getError('notEmpty') }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="suffix" *ngIf="isSuffixVisible()">
                  <label for="field-suffix">Suffix</label>
                  <mat-form-field appearance="outline" floatLabel="always">
                    <input
                      matInput
                      forbidAngleBrackets
                      type="text"
                      formControlName="suffix"
                      id="field-suffix"
                      autocomplete="suffix"
                      [placeholder]="getPlaceholderFor('Suffix')"
                      (change)="updateFieldValidatorStatus(page)"
                    />
                    <mat-error *ngIf="applicationForm.controls.suffix.hasError('maxlength')">
                      {{ getFailedValidationMessage('suffix', 'maxlength') }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <label for="field-email"
                >Email <span class="required" aria-label="This is a required field">*</span></label
              >
              <mat-form-field appearance="outline" floatLabel="always">
                <input
                  matInput
                  type="text"
                  formControlName="email"
                  id="field-email"
                  autocomplete="email"
                  placeholder="Required"
                  (change)="updateFieldValidatorStatus(page)"
                />
                <mat-error *ngIf="applicationForm.controls.email.hasError('notEmpty')">
                  {{ applicationForm.controls.email.getError('notEmpty') }}
                </mat-error>
                <mat-error *ngIf="applicationForm.controls.email.hasError('email')">
                  {{ getFailedValidationMessage('email', 'email') }}
                </mat-error>
              </mat-form-field>
              <lib-phone
                *ngIf="isPhoneNumberVisible()"
                label="Phone Number"
                [formGroup]="applicationForm"
                [required]="isRequired['PhoneNumber']"
              >
              </lib-phone>
              <address
                class="mb-24"
                *ngIf="addressHelper"
                [addressHelper]="addressHelper"
                [validateAddress]="form.validateAddress"
                (addressUpdated)="addressUpdated(page)"
              >
                <span class="sub-title">Mailing Address</span>
              </address>
              <span class="sub-title" *ngIf="isGenderVisible() || isRaceVisible()"
                >Demographics Information {{ !isRequired['Race'] && !isRequired['Gender'] ? '(Optional)' : '' }}</span
              >
              <div
                id="races"
                fxLayout="column"
                fxLayout.gt-xs="row"
                fxLayoutAlign="space-between"
                class="application-row demographics-row"
                *ngIf="isGenderVisible() || isRaceVisible()"
              >
                <div fxFlex="50" *ngIf="isRaceVisible()">
                  <div>
                    Race/Ethnicity (select all that apply)<span class="required">{{ getRequiredFor('Race') }}</span>
                  </div>
                  <div
                    fxLayout="column"
                    fxLayoutAlign="space-between"
                    [ngClass]="hasError('races', 'notEmpty') ? 'race-group-error' : 'race-group'"
                    role="group"
                    aria-label="What is your race or ethnicity? Select all that apply."
                  >
                    <div class="checkbox-required-text">
                      <div *ngIf="isRequired['Race']">Required</div>
                    </div>
                    <mat-checkbox
                      class="checkbox-label"
                      color="primary"
                      *ngFor="let race of races"
                      (change)="updateRace(race, $event); updateFieldValidatorStatus(page)"
                      [checked]="getRaceCheckboxStatus(race)"
                    >
                      {{ race.name }}
                    </mat-checkbox>
                    <label
                      class="race-error-message"
                      *ngIf="hasError('races', 'notEmpty')"
                      [attr.aria-label]="getFailedValidationMessage('races', 'notEmpty')"
                    >
                      {{ getFailedValidationMessage('races', 'notEmpty') }}
                    </label>
                  </div>
                </div>
                <div fxFlex *ngIf="isGenderVisible()">
                  <div>
                    Gender Identity<span class="required">{{ getRequiredFor('Gender') }}</span>
                  </div>
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-select
                      placeholder="{{ isRequired['Gender'] ? 'Required' : 'Gender' }}"
                      formControlName="gender"
                      aria-label="What is your gender identity"
                      (selectionChange)="updateFieldValidatorStatus(page)"
                    >
                      <mat-option [value]="">Select</mat-option>
                      <mat-option [value]="gender.Female">Female</mat-option>
                      <mat-option [value]="gender.Male">Male</mat-option>
                      <mat-option [value]="gender.NonBinary" *ngIf="isGenderSelectable('NonBinary')"
                        >Non-binary</mat-option
                      >
                      <mat-option [value]="gender.PreferNotToAnswer" *ngIf="isGenderSelectable('PreferNotToAnswer')"
                        >Prefer not to answer</mat-option
                      >
                    </mat-select>
                    <mat-error
                      [attr.aria-label]="getFailedValidationMessage('gender', 'notEmpty')"
                      *ngIf="hasError('gender', 'notEmpty')"
                    >
                      {{ getFailedValidationMessage('gender', 'notEmpty') }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>
          <form [formGroup]="applicationForm" fxLayout="column" *ngIf="isProfessionalInformationVisible()">
            <span class="sub-title">Professional Information</span>
            <div class="step-content">
              <div
                fxLayout="column"
                fxLayout.gt-xs="row"
                fxLayoutAlign="space-between"
                fxLayoutGap="20px"
                class="application-row"
              >
                <div fxFlex *ngIf="isJobTitleVisible()">
                  <label for="field-jobTitle">
                    Job Title<span class="required">{{ getRequiredFor('JobTitle') }}</span>
                  </label>
                  <mat-form-field appearance="outline" floatLabel="always">
                    <input
                      matInput
                      forbidAngleBrackets
                      type="text"
                      formControlName="jobTitle"
                      id="field-jobTitle"
                      [placeholder]="getPlaceholderFor('JobTitle')"
                      autocomplete="organization-title"
                      (change)="updateFieldValidatorStatus(page)"
                    />
                    <mat-error *ngIf="applicationForm.controls.jobTitle.hasError('notEmpty')">
                      {{ applicationForm.controls.jobTitle.getError('notEmpty') }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex *ngIf="isCompanyVisible()">
                  <label for="field-company">
                    Company<span class="required">{{ getRequiredFor('Company') }}</span>
                  </label>
                  <mat-form-field appearance="outline" floatLabel="always">
                    <input
                      matInput
                      forbidAngleBrackets
                      type="text"
                      formControlName="company"
                      id="field-company"
                      [placeholder]="getPlaceholderFor('Company')"
                      autocomplete="organization"
                      (change)="updateFieldValidatorStatus(page)"
                    />
                    <mat-error *ngIf="applicationForm.controls.company.hasError('notEmpty')">
                      {{ applicationForm.controls.company.getError('notEmpty') }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div
                fxLayoutAlign="space-between"
                fxLayout="column"
                class="application-row ms-block"
                *ngIf="isLinkedInVisible()"
              >
                <span>LinkedIn Profile</span>
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
                  <input
                    matInput
                    forbidAngleBrackets
                    type="text"
                    formControlName="linkedInProfile"
                    placeholder="LinkedIn Profile"
                    (change)="updateFieldValidatorStatus(page)"
                  />
                  <mat-error
                    *ngIf="
                      applicationForm.controls.linkedInProfile.hasError('urlPattern') &&
                      applicationForm.controls.linkedInProfile.touched
                    "
                  >
                    {{ getFailedValidationMessage('linkedInProfile', 'urlPattern') }}
                  </mat-error>
                  <mat-error *ngIf="applicationForm.controls.linkedInProfile.hasError('notEmpty')">
                    {{ applicationForm.controls.linkedInProfile.getError('notEmpty') }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div
                fxLayoutAlign="space-between"
                fxLayout="column"
                class="application-row ms-block"
                *ngIf="isResumeVisible()"
              >
                <span
                  >Resume or Curriculum Vitae<span class="required">{{ getRequiredFor('Resume') }}</span></span
                >
                <mat-form-field class="upload-resume-cv-field" appearance="outline" floatLabel="always" fxFlex="100%">
                  <input
                    matInput
                    type="text"
                    readonly="true"
                    formControlName="resumeUpload"
                    (click)="uploadResume.showUpload()"
                  />
                  <div fxFlex fxLayout="row" fxLayoutAlign="end">
                    <document-upload
                      #uploadResume
                      [doUpload]="false"
                      [doScan]="inPreviewMode ? false : true"
                      [onFileUpload]="onResumeUpload()"
                      [displayUploadButton]="displayUploadAndDeleteButtons"
                      (virusScanResultEvent)="processVirusScanResults($event, page)"
                      uploadText="Upload"
                      uploadButtonClass="mat-custom"
                      class="upload-resume"
                    ></document-upload>
                    <button
                      mat-icon-button
                      (click)="onResumeClear()"
                      *ngIf="!noResumeUploaded()"
                      type="button"
                      aria-label="Delete uploaded file"
                    >
                      <mat-icon *ngIf="displayUploadAndDeleteButtons">delete</mat-icon>
                    </button>
                  </div>
                  <mat-error *ngIf="applicationForm.controls.resumeUpload.hasError('notEmpty')">
                    {{ applicationForm.controls.resumeUpload.getError('notEmpty') }}
                  </mat-error>
                  <mat-error *ngIf="applicationForm.controls.resumeUpload.hasError('documentFailedScan')">
                    {{ this.uploadErrorMessage }}
                  </mat-error>
                  <mat-error *ngIf="applicationForm.controls.resumeUpload.hasError('documentScanRequestFailed')">
                    {{ this.uploadErrorMessage }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
        <attributes-editor
          #attributesEditor
          *ngIf="activePage.id == page.id"
          fxFlexWidth="100%"
          [formPage]="activePage"
          [dataSource]="attributesEditorDataSource"
          [useAttributeDescription]="true"
          [secureLinkId]="secureLinkId"
          [mode]="mode"
          (fieldUpdated)="updateFieldValidatorStatus(page)"
          (downloadFile)="downloadFile($event)"
        >
        </attributes-editor>
        <ng-container *ngTemplateOutlet="buttonBar; context: { i: i, page: page }"></ng-container>
      </mat-step>

      <mat-step>
        <application-payment [inPreviewMode]="inPreviewMode" [previewFormId]="previewFormId"></application-payment>

        <ng-container *ngTemplateOutlet="buttonBar; context: { i: totalPages - 1 }"></ng-container>
      </mat-step>

      <ng-template #buttonBar let-i="i" let-page="page">
        <div
          class="button-section"
          fxFlex
          fxLayout="column"
          [fxLayoutAlign]="totalPages === 1 ? 'center center' : 'center stretch'"
        >
          <validation-summary
            [failedValidations]="i === totalPages - 1 ? formFailedValidations : pageFailedValidations"
            [label]="i === totalPages - 1 ? 'form' : 'page'"
          >
          </validation-summary>

          <div class="submit-instructions" *ngIf="i === totalPages - 1">
            <em
              >You are submitting this application as <b>{{ application?.email }}.</b><br />
              Not you? <a target="_blank" href="{{ form?.requestUri }}">Click here</a> to access your personalized
              application.
            </em>
          </div>

          <ng-container [ngTemplateOutlet]="submitButton" *ngIf="totalPages === 1"></ng-container>

          <div fxFlex fxLayout="row" fxLayoutAlign="space-between center" *ngIf="totalPages !== 1">
            <div fxFlex fxLayoutAlign="start none">
              <button
                id="figure-out-id"
                mat-raised-button
                *ngIf="i !== 0"
                type="button"
                fxLayoutAlign="start none"
                matStepperPrevious
                class="back-button"
                (click)="onBackClick()"
              >
                <div fxFlex fxLayout="row" fxLayoutAlign="center center">
                  <mat-icon>arrow_back</mat-icon>
                  <span>BACK</span>
                </div>
              </button>
            </div>
            <div>PAGE {{ i + 1 }} of {{ totalPages }}</div>
            <div fxFlex fxLayoutAlign="end none" *ngIf="i !== totalPages - 1; else submitButton">
              <button
                mat-raised-button
                type="button"
                class="mat-primary next-button"
                (click)="onNextClick(page)"
                matStepperNext
              >
                <div fxFlex fxLayout="row" fxLayoutAlign="center center">
                  <span>NEXT</span>
                  <mat-icon>arrow_forward</mat-icon>
                </div>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-stepper>
  </div>
</div>

<ng-template #submitButton>
  <div fxFlex fxLayoutAlign="end none">
    <button
      id="submit-button-last"
      mat-raised-button
      type="button"
      class="mat-primary submit-button"
      [disabled]="disableSubmit"
      appThrottleClick
      (throttledClick)="submitApplication()"
    >
      <div fxFlex fxLayout="row" fxLayoutAlign="center center">
        <mat-icon>done</mat-icon>
        <span>SUBMIT</span>
      </div>
    </button>
  </div>
</ng-template>
